import { styled } from "goober";
import { ToggleButton } from "../HeadingToggle";

export const ChatpadButton = styled(ToggleButton)`
  border-radius: 9999px;
  &:focus-visible {
    outline: 2px solid var(--focus-ring);
    outline-offset: -2px;
  }
`;
